import { render, staticRenderFns } from "./SwiftLogin.vue?vue&type=template&id=4bb3099b&"
import script from "./SwiftLogin.vue?vue&type=script&lang=js&"
export * from "./SwiftLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports